import React from 'react';
import PropTypes from 'prop-types';

import { ModalBody, ModalTitle } from '@vds/modals';
import { Title } from '@vds/typography';

import AddressConfirmationModal from './AddressConfirmationModal';
import SelectPhoneNumber from './selectPhoneNumberModal';
import { isValidZipCode, isBetween } from '../../../../../common/validation';
import { VDSModal as Modal } from '../../../../../common/Modal/VDSModal';

import { store } from '../../../../../../configureStore';
import Notification from '../../../../../common/Notification/index';
import { saveItemToStore } from '../../../../../../utils/sessionStorage';
import { isMobile } from '../../../../../common/Helpers/index';
import { logMetrics, ACCESSORIES, USER_INFO, CONFIRMADDRESS_CONTINUECLICK, ADDHOME_PHONECLICK } from '../../../../../../services/metricsService';
import { getLqAddress } from '../../../../../common/addressUtils';
import { Margin } from '../../../../../common/styles';

class HomePhoneModalComp extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedAddressOption: props.selectedAddressOption,
      noE911EligibleError: false,
      enableAddHomeButton: false,
      enablePhoneNumberDropdown: true,
      continueButtonclicked: false,
      zipCode: '',
      displayError: false,
      zipCodeEnable: false,
      selectedMTN: '',
      emergencyAddressList: '',
      selectedNgp1: '',
      showError: false,
      hideNotificationCalled: false,
      selectedPlan: '',
      addressSelected: false,
    };
    this.isMobile = isMobile();
  }

  componentDidMount() {
    if (this.props.propsList && this.props.propsList.showAddNotification && this.props.propsList.showAddNotification !== '') {
      this.hideNotification();
    }
    if (this.props.opened) {
      this.onCancelClick();
    }
  }

  componentDidUpdate(_, prevProps) {
    if (prevProps.propsList !== this.props.propsList) {
      if (this.props.propsList.isE911Call && this.props.propsList.e911CallSuccess) {
        const statusCode = this.props?.propsList?.validatee911Response?.validateAddress?.e911Address?.statusCode || '';
        if (statusCode === 'VALID') {
          this.setState({ continueButtonclicked: true });
        } else if (statusCode !== 'VALID') {
          this.setState({ continueButtonclicked: false });
          this.setState({ showError: true });
        }
      } else if (!this.props.propsList.isE911Call || !this.props.propsList.e911CallSuccess) {
        this.setState({ continueButtonclicked: false });
        this.setState({ showError: false });
      }
    }
  }

  onAddress = (val) => {
    this.setState({ selectedAddressOption: val.selectedAddressOption });
  };

  onAddressSelected = (val) => {
    this.setState({ addressSelected: val });
  };

  onClickContinue = () => {
    const lqShippingAddress = getLqAddress();
    if (lqShippingAddress) {
      const { addressLine1, addressLine2, city, state, zipCode, fullAddress } = lqShippingAddress;
      if (!this.state.selectedAddressOption) {
        this.setState({ selectedAddressOption: fullAddress });
      }

      const data = {
        addressLine1,
        addressLine2,
        state,
        city,
        zipCode,
      };
      this.setState({ zipCode });
      this.props.propsList.validateE911Address(data);
    }

    store.dispatch({ type: 'IS_E911_CALL', value: true });
    logMetrics(ACCESSORIES, USER_INFO, CONFIRMADDRESS_CONTINUECLICK);
  };

  changeLink = () => {
    const lqShippingAddress = getLqAddress();
    if (lqShippingAddress) {
      const { zipCode } = lqShippingAddress;
      this.setState({ zipCode });
    }

    this.setState({ continueButtonclicked: false, enableAddHomeButton: false });
    //  this.props.propsList.validateE911Address(data);
    store.dispatch({ type: 'IS_E911_CALL', value: false });
    logMetrics(ACCESSORIES, USER_INFO, CONFIRMADDRESS_CONTINUECLICK);
  };

  onCancelClick = () => {
    this.setState({ continueButtonclicked: false });
    this.props.closeModal();
    store.dispatch({ type: 'IS_E911_CALL', value: false });
  };

  handleZipCodeChange = (val) => {
    this.setState({
      enableAddHomeButton: false,
      enablePhoneNumberDropdown: false,
      selectedMTN: '',
    });
    if (isValidZipCode(val) && isBetween(val, 501, 99950)) {
      this.setState({
        zipCode: val,
        displayError: false,
        enablePhoneNumberDropdown: true,
      });
      if (val.length === 5) {
        const postData = {
          zipcode: val,
        };
        this.props.propsList.callNPANXXOnHp(postData);
      }
    } else if (!isValidZipCode(val)) {
      this.setState({
        zipCode: val,
        zipCodeEnable: false,
        displayError: true,
      });
    }
    if (val.length === 5 && this.state.selectedMTN) {
      this.setState({ enableAddHomeButton: true });
    }
    this.props.propsList.saveZip(val);

    return false;
  };

  mtnSelection = (val) => {
    const mtn = val.target.value;
    this.setState({ selectedMTN: mtn });
    if (this.state.zipCode) {
      this.setState({ enableAddHomeButton: true });
    }
  };

  addHomePhoneButtonClick = () => {
    const { selectedAddressOption, selectedMTN } = this.state;
    let result;
    const lqShippingAddress = getLqAddress();
    const { zipCode = '', city = '', fipsCode = '', addressLine1 = '', state = '' } = lqShippingAddress || {};

    const params = {
      Address: selectedAddressOption,
      npaNXX: selectedMTN,
    };
    this.setState({
      emergencyAddressList: params,
      continueButtonclicked: false,
    });
    this.props.closeModal(this.state);
    const values = this.state;
    store.dispatch({ type: 'EMERGENCY_ADDRESS', values });
    const mtn = this.state.selectedMTN.replace('-XXXX', '');
    const npanxxValue = mtn.replace('-', '');
    const items =
      this.props.propsList.getNPANXX && this.props.propsList.getNPANXX.data && this.props.propsList.getNPANXX.data.npanxxlist
        ? this.props.propsList.getNPANXX.data.npanxxlist
        : null;
    const mtnval = items.map((item) => ({ [item.npa.concat(`-${item.nxx}`)]: item.ngp1 }));
    mtnval.forEach((val) => {
      const response = val[mtn];
      if (response) {
        result = response;
      }
    });
    const value = {
      npanxx: npanxxValue,
      ngp1: result,
    };
    const data = {
      prodId: this.props.homePhoneID,
      qty: '1',
      planId: this.props.homeProdId,
      zipCode,
      city,
      fipsCode,
      addressLine1,
      state,
      npanxxValue,
      depletionType: this.props.depletionType,
    };
    saveItemToStore('home_line', npanxxValue);
    this.props.propsList.isHomeLineCall(npanxxValue);
    const oddOnList = this.props && this.props.propsList && this.props.propsList.addonObj ? this.props.propsList.addonObj : [];
    this.props.propsList.showLoader();
    // this.props.propsList.isNpaCallNeed('Y');
    // this.props.propsList.isNpaCallNeed('Y');
    store.dispatch({ type: 'ASSIGN_MTN_VALUES', value });
    this.props.propsList.postAddToCart(data, 'homePhoneService', oddOnList, 'addToCart');
    if (!this.props.skipBtnCall) {
      store.dispatch({ type: 'SHOW_SKIP_BTN', response: true });
      store.dispatch({ type: 'SKIP_BTN_CALLED', response: true });
    }
    setTimeout(() => {
      this.showNotification('Home Phone Service', 0, this.props.homePhoneID);
      setTimeout(() => {
        this.hideNotification();
      }, 5000);
    }, 7000);
    this.setState({ hideNotificationCalled: true });
    logMetrics(ACCESSORIES, USER_INFO, ADDHOME_PHONECLICK);
    // this.props.propsList.callAssignMtn(value);
  };

  showNotification = (displayName, count, prodID) => {
    let verbiage = '';
    this.setState({ hideNotificationCalled: false, selectedPlan: prodID });
    if (!this.isMobile) {
      verbiage = `${(count && count !== 0) || ''} ${displayName !== undefined ? displayName : ''} is added to your cart.`;
      this.props.propsList.showAddonNotification(verbiage);
    } else if (this.isMobile) {
      this.props.propsList.showAddonNotification('');
    }
  };

  hideNotification = () => {
    this.props.propsList.showAddonNotification('');
  };

  render() {
    const { opened, propsList, homePhoneID, title, price } = this.props;
    let landline = '';
    if (homePhoneID !== '') {
      landline = propsList.plansReferenceData && propsList.plansReferenceData[homePhoneID];
    }
    let modalBody = '';

    if (!this.state.continueButtonclicked) {
      modalBody = (
        <>
          {this.state.showError ? (
            <Notification
              hideCloseButton="true"
              type="error"
              title={
                this.props.e911ErrorText
                  ? this.props.e911ErrorText
                  : "The address you provided doesn't show up in the e911 database. You cannot purchase Home Phone without a confirmed address for emergency response. For more information call 866.21.2223"
              }
              subtitle=""
            />
          ) : (
            <AddressConfirmationModal
              selectedAddressOption={this.state.selectedAddressOption}
              propsList={propsList}
              closeModal={this.onCancelClick}
              onAddress={this.onAddress}
              onClickContinue={this.onClickContinue}
              landline={landline}
              addressSelected={this.state.addressSelected}
              onAddressSelected={this.onAddressSelected}
            />
          )}
        </>
      );
    } else {
      modalBody = (
        <SelectPhoneNumber
          propsList={propsList}
          selectedAddressOption={this.state.selectedAddressOption}
          zipCode={this.state.zipCode}
          displayError={this.state.displayError}
          handleZipCodeChange={this.handleZipCodeChange}
          closeModal={this.onCancelClick}
          mtnSelection={this.mtnSelection}
          changeLink={this.changeLink}
          enableAddHomeButton={this.state.enableAddHomeButton}
          addHomePhoneButtonClick={this.addHomePhoneButtonClick}
          enablePhoneNumberDropdown={this.state.enablePhoneNumberDropdown}
          landline={landline}
        />
      );
    }

    document.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) this.onCancelClick();
    });

    return (
      <Modal
        id="homePhoneModal"
        opened={opened}
        onOpenedChange={(e) => {
          this.props.onOpenedChange();
          if (!e) {
            this.onCancelClick();
          }
        }}
        disableOutsideClick
        analyticstrack="HomePhoneService Modal - open"
        ariaLabel="HomePhoneService Modal"
      >
        <ModalTitle primitive="p">
          <Title size="large" primitive="h2">
            {title}
          </Title>
          <Title size="large" primitive="h2">
            {`$${price}/mo*`}
          </Title>
        </ModalTitle>

        <ModalBody>
          <Margin bottom="2px" left="5px">
            {modalBody}
          </Margin>
        </ModalBody>
      </Modal>
    );
  }
}

HomePhoneModalComp.propTypes = {
  selectedAddressOption: PropTypes.string,
  propsList: PropTypes.object,
  homePhoneID: PropTypes.string,
  homeProdId: PropTypes.string,
  closeModal: PropTypes.func,
  opened: PropTypes.bool,
  validateE911Address: PropTypes.func,
  e911ErrorText: PropTypes.any,
  depletionType: PropTypes.string,
  onOpenedChange: PropTypes.any,
  skipBtnCall: PropTypes.any,
  title: PropTypes.string,
  price: PropTypes.string,
};
export default HomePhoneModalComp;
